import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {User} from '../../../api/entity/user.model';
import {UserConverter} from '../../../api/converter/user.converter';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';


@Injectable({providedIn: 'root'})
export class UserDataService extends AbstractDataServiceV2<User, UserConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: UserConverter) {
        super('User', http, httpUrlGenerator, logger, config, converter);
    }
}
